/** An amplitude hint, not a speech recognizer. Never submits a request. */
export function createSilenceTracker() {
    let onset: number | null = null;
    let lastSpeech: number | null = null;
    let spoke = false;
    let paused = false;
    return {
        frame(level: number, now: number, pause: boolean): boolean {
            if (pause) {
                onset = null;
                lastSpeech = null;
                paused = true;
                return false;
            }
            if (paused) {
                paused = false;
                lastSpeech = spoke ? now : null;
            }
            if (level >= .12) {
                onset ??= now;
                if (now - onset >= 300)
                    spoke = true;
                if (spoke)
                    lastSpeech = now;
                return false;
            }
            onset = null;
            return spoke && lastSpeech !== null && now - lastSpeech >= 5000;
        },
        hasSpeech: () => spoke,
    };
}
export const INTRO_VERSION = 'agent-intro-v1';
export const introKey = (user: string, client: string) => `worki.${INTRO_VERSION}.${client}.${user}`;
export function createIntroStore(storage: Pick<Storage, 'getItem' | 'setItem'> | undefined) {
    const memory = new Set<string>();
    return {
        claim(key: string, owner: string, now: number) {
            try {
                const leaseKey = key + '.lease';
                const raw = storage?.getItem(leaseKey);
                const lease = raw ? JSON.parse(raw) as {
                    owner: string;
                    until: number;
                } : null;
                if (lease && lease.until > now && lease.owner !== owner)
                    return false;
                storage?.setItem(leaseKey, JSON.stringify({ owner, until: now + 600000 }));
                return true;
            }
            catch {
                return true;
            }
        },
        release(key: string, owner: string) {
            try {
                const leaseKey = key + '.lease';
                const raw = storage?.getItem(leaseKey);
                if (raw && (JSON.parse(raw) as {
                    owner: string;
                }).owner === owner)
                    storage?.setItem(leaseKey, '');
            }
            catch { /* Blocked storage uses session memory. */ }
        },
        seen(key: string) { try {
            return memory.has(key) || storage?.getItem(key) === '1';
        }
        catch {
            return memory.has(key);
        } },
        mark(key: string) { memory.add(key); try {
            storage?.setItem(key, '1');
        }
        catch { /* Session memory still prevents reopening. */ } },
    };
}
export const safeIntroPath = (path: string) => ['/', '/inquiries', '/quotes', '/invoices', '/reminders', '/agent'].includes(path);
export function canAutoIntro(path: string, search: string, busy: boolean, dialog: boolean) {
 return safeIntroPath(path) && !new URLSearchParams(search).has('run') && !busy && !dialog;
}
